import {currentUserMeetsUserLevel} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {isMobile} from '@netx/core-next/utils/browser';
import {STATS_VIEW_MINIMUM_USER_LEVEL} from './constants';

export const canViewStats = () =>
	!isMobile() && currentUserMeetsUserLevel(STATS_VIEW_MINIMUM_USER_LEVEL);
